<template>
  <pre class="code-editor textfield prism" :disabled="disabled"></pre>
</template>

<script>
import Prism from 'prismjs';
import 'prismjs/components/prism-yaml';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-markup-templating';
import 'prismjs/components/prism-handlebars';
import 'prismjs/components/prism-javascript';
import cledit from '../services/editor/cledit';

export default {
  props: ['value', 'lang', 'disabled'],
  data() {
    return {
      clEditor: null,
    };
  },
  mounted() {
    const preElt = this.$el;
    let scrollElt = preElt;
    while (scrollElt && !scrollElt.classList.contains('modal')) {
      scrollElt = scrollElt.parentNode;
    }
    // Use preElt as fallback if no modal found
    scrollElt = scrollElt || preElt;
    this.clEditor = cledit(preElt, scrollElt);
    this.clEditor.on('contentChanged', value => this.$emit('changed', value));
    const grammar = Prism.languages[this.lang] || Prism.languages.plaintext || {};
    this.clEditor.init({
      content: this.value || '',
      sectionHighlighter: section => Prism.highlight(section.text, grammar, this.lang || 'plaintext'),
    });
    this.clEditor.toggleEditable(!this.disabled);
  },
  watch: {
    value(newVal) {
      if (this.clEditor && newVal !== undefined && newVal !== null) {
        const currentContent = this.clEditor.getContent();
        if (currentContent !== newVal) {
          this.clEditor.setContent(newVal);
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import '../styles/variables.scss';

.code-editor {
  margin: 0;
  font-family: $font-family-monospace;
  font-size: $font-size-monospace;
  font-variant-ligatures: no-common-ligatures;
  word-break: break-word;
  word-wrap: normal;
  height: auto;
  caret-color: #000;
  color: #333;
  background-color: #fff;
  min-height: 160px;
  overflow: auto;
  padding: 0.2em 0.4em;

  .app--dark & {
    caret-color: #d4d4d4;
    color: #d4d4d4;
    background-color: #1e1e1e;
  }

  .app--monokai & {
    color: #f8f8f2;
    caret-color: #f8f8f2;
    background-color: #272822;
  }

  .app--dracula & {
    color: #f8f8f2;
    caret-color: #f8f8f2;
    background-color: #282a36;
  }

  .app--nord & {
    color: #d8dee9;
    caret-color: #d8dee9;
    background-color: #2e3440;
  }

  .app--solarized-dark & {
    color: #93a1a1;
    caret-color: #93a1a1;
    background-color: #002b36;
  }

  .app--solarized-light & {
    color: #586e75;
    caret-color: #586e75;
    background-color: #fdf6e3;
  }

  .app--sepia & {
    color: #5b4636;
    caret-color: #5b4636;
    background-color: #f4ecd8;
  }

  * {
    line-height: $line-height-base;
    font-size: inherit !important;
  }
}
</style>
